/** Legacy PHP writers HTML-escape names before storage; Vue renders them as plain text. */
export function decodeOrgReferenceText(value) {
  if (typeof value !== 'string') return value;
  const entities = { amp: '&', quot: '"', apos: "'", lt: '<', gt: '>', '#039': "'", '#39': "'" };
  return value.replace(/&(amp|quot|apos|lt|gt|#039|#39);/g, (match, key) => entities[key]);
}

export function normalizeOrgReferenceRow(row) {
  if (!row || typeof row !== 'object') return row;
  const result = { ...row };
  for (const field of ['name', 'label', 'address', 'city', 'state']) {
    if (typeof result[field] === 'string') result[field] = decodeOrgReferenceText(result[field]);
  }
  return result;
}

export function normalizeOrgReferenceOptions(data) {
  if (!data || typeof data !== 'object') return data;
  const result = { ...data };
  for (const key of ['departments', 'positions', 'grades', 'locations', 'sub_departments', 'teams']) {
    if (Array.isArray(data[key])) result[key] = data[key].map(normalizeOrgReferenceRow);
  }
  return result;
}
